'use client';

import { uniqBy } from 'es-toolkit';
import { t } from 'mobx-state-tree';

import { PropertyType } from '../propertyType';

import { PropertyBase } from './propertyBase';


import type { SelectOptionsTypes } from '../types';
import type { Instance } from 'mobx-state-tree';

import { displayCase } from '@/editor/core/nameHelpers';

/** Model for select property */
export const SelectProperty = t.compose('SelectProperty', PropertyBase,
  t.model({
    type: t.literal(PropertyType.Select),
    value: t.optional(t.string, ''),
    defaultValue: t.optional(t.string, ''),
    options: t.array(t.model({
      label: t.string,
      value: t.string,
    })),
    placeholder: t.optional(t.string, '')
  })
).actions(self => ({
  setValue(value: string, fromPanel = true, initial = false) {
    if (!self.options.some(opt => opt.value === value)) {
      console.warn(`Invalid option value: ${value}`);
      return;
    }
    if (value === self.value) return;
    self.value = value;
    self.notifyValueChange(self.path, value, { fromPanel, initial, property: self as Instance<typeof SelectProperty> });
  },
  setDefaultValue(value: string) {
    // Only validate if options are available
    if (self.options.length > 0 && !self.options.some(opt => opt.value === value)) {
      console.warn(`Invalid option value for default: ${value}. Available options:`, self.options.map(o => o.value));
      return;
    }
    self.defaultValue = value;
  },
  setOptions(options: SelectOptionsTypes) {
    let mappedOptions;
    if (Array.isArray(options)) {
      if (options.length && typeof options[0] === 'string') {
        mappedOptions = (options as string[]).map(opt => ({ label: displayCase(opt), value: opt }));
      } else {
        mappedOptions = (options as Array<{ label: string; value: string }>)
          .map(opt => ({ label: displayCase(opt.label), value: opt.value }));
      }
    } else {
      mappedOptions = Object.entries(options)
        .map(([value, label]) => ({ label: displayCase(label), value }));
    }
    self.options.replace(uniqBy(mappedOptions, opt => opt.label));
  },
  addOption(option: { label: string, value: string }) {
    self.options.push(option);
  },
  removeOption(value: string) {
    const index = self.options.findIndex(opt => opt.value === value);
    if (index !== -1) self.options.splice(index, 1);
  }
}));